"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteEmail = deleteEmail;
exports.getEmailById = getEmailById;
exports.getEmails = getEmails;
exports.getGoogleLoginUrl = getGoogleLoginUrl;
exports.markAsRead = void 0;
exports.syncInbox = syncInbox;
var _request = _interopRequireDefault(require("@/utils/request"));
function getEmails(query) {
  return (0, _request.default)({
    url: '/email',
    method: 'get',
    params: query
  });
}
function getEmailById(id) {
  return (0, _request.default)({
    url: `/email/${id}`,
    method: 'get'
  });
}
const markAsRead = id => {
  return (0, _request.default)({
    url: `/email/read/${id}`,
    method: 'patch'
  });
};
exports.markAsRead = markAsRead;
function deleteEmail(id) {
  return (0, _request.default)({
    url: `/email/${id}`,
    method: 'delete'
  });
}
function syncInbox(accountId) {
  return (0, _request.default)({
    url: '/email/sync',
    method: 'post',
    params: accountId ? {
      accountId
    } : {}
  });
}
function getGoogleLoginUrl() {
  return (0, _request.default)({
    url: '/get-google-login-url',
    method: 'get'
  });
}